import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

// Default video URL (fallback)
const DEFAULT_VIDEO_URL = 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4';

const OnboardingWelcomeVideo = ({ onComplete, onSkip }) => {
  const [welcomeVideoUrl, setWelcomeVideoUrl] = useState(DEFAULT_VIDEO_URL);
  const [loadingVideo, setLoadingVideo] = useState(true);
  const [videoEnded, setVideoEnded] = useState(false);

  useEffect(() => {
    loadVideoUrl();
  }, []);

  const loadVideoUrl = async () => {
    try {
      const docRef = doc(db, 'onboardingSettings', 'settings');
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data?.welcomeVideoUrl) {
          setWelcomeVideoUrl(data.welcomeVideoUrl);
        }
      }
    } catch (error) {
      console.error('Error loading welcome video URL:', error);
      // Use default on error
    } finally {
      setLoadingVideo(false);
    }
  };

  const handleVideoEnd = () => {
    setVideoEnded(true);
    // Auto-advance after a moment
    setTimeout(() => {
      onComplete();
    }, 1000);
  };

  if (loadingVideo) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0076BE] to-[#5ABA47] flex items-center justify-center">
        <div className="text-white text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p>Loading welcome video...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0076BE] to-[#5ABA47] relative">
      {/* Skip Button */}
      <button
        onClick={onSkip}
        className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-black/30 hover:bg-black/50 flex items-center justify-center text-white transition-colors"
        aria-label="Skip video"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Video Container */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="w-full max-w-4xl">
          <div className="aspect-video bg-black rounded-lg overflow-hidden shadow-2xl">
            <iframe
              src={welcomeVideoUrl.includes('vimeo.com') 
                ? welcomeVideoUrl.replace('/video/', '/video/') 
                : welcomeVideoUrl}
              className="w-full h-full"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              onLoad={() => {
                // Video loaded
              }}
            ></iframe>
          </div>

          {/* Welcome Text Overlay */}
          <div className="mt-8 text-center">
            <h1 className="text-4xl font-bold text-white mb-4 drop-shadow-lg">
              Welcome to Together On Mission
            </h1>
            <p className="text-xl text-white/90 drop-shadow-md">
              Let's get you started on your discipleship journey
            </p>
          </div>

          {/* Continue Button (shown when video ends) */}
          {videoEnded && (
            <div className="mt-8 flex justify-center">
              <button
                onClick={onComplete}
                className="px-8 py-3 bg-white text-[#0076BE] font-semibold rounded-lg hover:bg-gray-100 transition-colors shadow-lg"
              >
                Continue
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingWelcomeVideo;
